<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :maskClosable="false"
    :keyboard="false">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="片单名称" prop="name">
        <a-input v-model="form.name" placeholder="片单名称" />
      </a-form-model-item>
      <a-form-model-item label="片单底图" prop="playlistBgUrl">
        <a-upload listType="picture-card" class="avatar-uploader" :fileList="[]" :showUploadList="false"
          :customRequest="handleChange">
          <img v-if="form.playlistBgUrl" :src="form.playlistBgUrl" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {
  addCustomizeForm,
  editCustomizeForm,
  delCustomizeForm,
  getCustomizeFormDetail
} from '@/api/video/video'
import Editor from '@/components/Editor'
import UploadFileToVOD from "@/api/vod.js"

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        name: null,
        type: null,
        language: null,
        playlistBgUrl: null
      },
      // 1增加,2修改
      formType: 1,
      uploadLoading: false,
      open: false,
      rules: {
        name: [
          { required: true, message: '内容不能为空' }
        ]
      }
    }
  },
  filters: {
  },
  created() {
  },
  computed: {
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    beforeUpload: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        this.uploadLoading = false
        return false;
      }
      this.form.playlistBgUrl = ""
      //TODO 驗證文件大小
    },
    handleChange(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.playlistBgUrl = fileName[0];//文件名
          that.uploadLoading = false;
        },

      });

    },
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      // this.form = {
      //   id: null,
      //   name: null,
      //   createTime: null,

      // }
      this.form.id = null
      this.form.name = null
      this.form.type = null
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd(type, language) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
      this.form.type = type
      this.form.language = language
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      //   this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCustomizeFormDetail({ 'id': id }).then(response => {
        this.form = response.data
        debugger
        console.log(this.form)
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          this.form.isDeleted = null;
          console.log('表单内容：', this.form)
          if (this.form.id !== undefined && this.form.id !== null) {
            console.log('表单内容：', this.form)
            editCustomizeForm(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCustomizeForm(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
